import { ValidateRuleDirective } from './validateRule.directive';
import { ValidationRules } from './validationRules.constants';
import { ValidationRulesProvider } from './validationRules.provider';

export default angular
  .module('ng1-form-validation', [])
  .directive('validateRule', ValidateRuleDirective)
  .provider('validationRules', ValidationRulesProvider)
  .constant('ValidationRules', ValidationRules)
  .name;
